import React, { useState } from 'react';
import InputColor from 'react-input-color';

const InputColorField = (data) => {
    const [color, setColor] = useState({});

    function onchangeAll(e, name) {
        data.onchangeColor(e, name);
        // console.log(color);
        setColor(e);
    }

    const onChangeInput = (e) => {
        data.onChangeFromInput(e.target.value, data.name);
        setColor(e.target.value);
    }
    return (
        <div className="yr-color-picker">
            <InputColor style={{ width: "65%", height: "30px", padding: "0" }} initialValue={data.value} onChange={(evt) => onchangeAll(evt, data.name)} />
            <span className='colorspan'>
                <input type="text" value={color.hex} defaultValue={color.hex} onChange={onChangeInput} max={9} maxLength={9} />
            </span>
        </div>
    )
}


export default InputColorField;